module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("Arquivo shape:")]), _c('shape-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "shapeInput",
    attrs: {
      "name": "shape",
      "max-file-size": _vm.tamanhoMaximoShapeMB,
      "max-geometries": 1,
      "accept-polygons": true
    },
    on: {
      "input": _vm.onShapeChange
    },
    model: {
      value: (_vm.geoJsonShape),
      callback: function($$v) {
        _vm.geoJsonShape = $$v
      },
      expression: "geoJsonShape"
    }
  }), _c('input-errors', {
    attrs: {
      "name": "shape"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00ceb25e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/inspecao/InspecaoShape.vue
// module id = 463
// module chunks = 1